export default {
    local: {
        VUE_APP_ENV: `local`,
        VUE_APP_CURRENT_URL: `http://localhost:2253`,
        VUE_APP_API_URL: `http://localhost:8100`,
        VUE_APP_PAYPAL_CLIENT: `AefvHD-oUP1vwlPhbEuq_HvIpddkqKdRq6chcV3b903aUHeceMRc1cH_UU990uO3ULrY1HzFm57nXl41`,
        VUE_APP_SQUARE_APP_ID: `sandbox-sq0idb-j_RsacKbOmoiv6hyYNxJ0w`,
        VUE_APP_SQUARE_LOCATION_ID: `LY44F744Y4859`
    },
    dev: {
        VUE_APP_ENV: `dev`,
        VUE_APP_CURRENT_URL: `https://dev.portal.eyein.media`,
        VUE_APP_API_URL: `https://dev.api.eyein.media`,
        VUE_APP_PAYPAL_CLIENT: `AefvHD-oUP1vwlPhbEuq_HvIpddkqKdRq6chcV3b903aUHeceMRc1cH_UU990uO3ULrY1HzFm57nXl41`,
        VUE_APP_SQUARE_APP_ID: `sandbox-sq0idb-j_RsacKbOmoiv6hyYNxJ0w`,
        VUE_APP_SQUARE_LOCATION_ID: `LY44F744Y4859`

    },
    demo: {
        VUE_APP_ENV: `demo`,
        VUE_APP_CURRENT_URL: `https://portal.eyein.media`,
        VUE_APP_API_URL: `https://api.eyein.media`,
        VUE_APP_PAYPAL_CLIENT: `ATg5FZwt-flITavvueGoDWeUmThSiRF2ZxuyZpWLUnbw02y8gW0w4L5aiR7SmZ0m1jJHEd1FcAXmOM3N`,
        VUE_APP_SQUARE_APP_ID: `sq0idp-JAiN1YG-mxFQ9fH8MLVpSQ`,
        VUE_APP_SQUARE_LOCATION_ID: `A62XV799K6AS6`
    },
    live: {
        VUE_APP_ENV: `live`,
        VUE_APP_CURRENT_URL: `https://portal.eyein.media`,
        VUE_APP_API_URL: `https://api.eyein.media`,
        VUE_APP_PAYPAL_CLIENT: `ATg5FZwt-flITavvueGoDWeUmThSiRF2ZxuyZpWLUnbw02y8gW0w4L5aiR7SmZ0m1jJHEd1FcAXmOM3N`,
        VUE_APP_SQUARE_APP_ID: `sq0idp-JAiN1YG-mxFQ9fH8MLVpSQ`,
        VUE_APP_SQUARE_LOCATION_ID: `A62XV799K6AS6`
    }
};
